export const LOAD_SRACUSTOMERS_SUCCESS = "LOAD_SRACUSTOMERS_SUCCESS";

export const CREATE_SRACUSTOMER_SUCCESS = "CREATE_SRACUSTOMER_SUCCESS";

export const SAVE_SRACUSTOMER_SUCCESS = "SAVE_SRACUSTOMER_SUCCESS";

export const DELETE_SRACUSTOMER_SUCCESS = "DELETE_SRACUSTOMER_SUCCESS";

export const ACTIVATE_SRA_CUSTOMER_SUCCESS = "ACTIVATE_SRA_CUSTOMER_SUCCESS";

export const DEACTIVATE_SRA_CUSTOMER_SUCCESS = "DEACTIVATE_SRA_CUSTOMER_SUCCESS";

export const LOAD_SRACUSTOMER_DETAIL_SUCCESS = "LOAD_SRACUSTOMER_DETAIL_SUCCESS";

export const ACTIVATE_SRA_CUSTOMER = "ACTIVATE_SRA_CUSTOMER";
export const DEACTIVATE_SRA_CUSTOMER = "DEACTIVATE_SRA_CUSTOMER";
